import { createContext, type ReactNode } from 'react';

export interface EmbeddedContextValue {
  isEmbedded: boolean;
}

export const EmbeddedContext = createContext<EmbeddedContextValue>({ isEmbedded: false });

export function EmbeddedProvider({ children }: { children: ReactNode }) {
  return <EmbeddedContext.Provider value={{ isEmbedded: true }}>{children}</EmbeddedContext.Provider>;
}
